<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-item ref="store_name" label="所属门店" name="store_name" >
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.store_name" readonly placeholder='请选择门店' />
            </a-col>
            <a-col :span="8" v-if="!formData.id">
              <a-button type="primary" @click='showStore = true' :disabled='formData.type == "look"'>选择</a-button>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="type_id" label="店员类型" name="type_id">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-select v-model:value="form.type_id" placeholder="请选择店员类型" :disabled='formData.type == "look"' @change="handleChange">
                <a-select-option v-for='item in typeList' :key='item.id' :value="item.id">{{item.type_name}}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <a href="javascript:;" @click="()=> {$router.push('/customer/clerk/clerk_level_setup?active=3')}">设置店员类型</a>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="level_id" label="店员级别" name="level_id">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-select v-model:value="form.level_id" placeholder="请选择店员级别" :disabled='formData.type == "look" || !form.type_id'>
                <a-select-option v-for='item in levelList' :key='item.id' :value="item.id">{{item.level_name}}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="8">
              <a href="javascript:;" @click="()=> {$router.push('/customer/clerk/clerk_level_setup?active=1')}">设置店员级别</a>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="clerk_name" label="店员名称" name="clerk_name">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.clerk_name" placeholder='请输入店员名称' :disabled='formData.type == "look"'  :maxlength="10" />
            </a-col>
            <a-col :span="8">
              <p>最多10个字</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="clerk_phone" label="手机号" name="clerk_phone">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.clerk_phone" placeholder='请输入店员手机号' :disabled='formData.type == "look"' :maxlength="11" v-inputFilter:phone />
            </a-col>
            <a-col :span="8">
              <p>11位手机号码</p>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="clerk_password" label="设置密码" name="clerk_password" v-if='formData.type !== "look"' help="默认123456">
          <a-row :gutter="16">
            <a-col :span="16">
              <a-input v-model:value="form.clerk_password" placeholder='请输入密码'/>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item ref="" label="核销订单" name="is_can_verify"  :rules="[{ required: true, message: '请选择' }]">
          <a-radio-group v-model:value="form.is_can_verify" :disabled='formData.type == "look"'>
            <a-radio :value="1">
              允许核销门店所有订单
            </a-radio>
            <a-radio :value="2">
              只允许核销自己的订单
            </a-radio>
            <a-radio :value="0">
              不允许
            </a-radio>
          </a-radio-group>
        </a-form-item>
        
        <a-form-item :wrapper-col="{ span: 8, offset: 3 }" v-if='formData.type !== "look"'>
          <a-button type="primary" @click="onSubmit">
            保存
          </a-button>
        </a-form-item>
      </a-form>
    </a-card>
  </a-layout>
  <a-modal  :keyboard="false" centered title="选择门店" v-model:visible="showStore" :width='1300' :footer="null" destroyOnClose>
    <selectStore v-on:select="select" :dealer_id='dealer_id' :hiddenHead='true' :selectList='storeList'></selectStore>
  </a-modal>
</template>
<script>
  import { ref, onMounted, reactive, toRefs, inject, watchEffect } from 'vue';
  import { message } from 'ant-design-vue';
  import { iscode } from "@/utils/app";
  import { getStoreClerkMore } from "@/api/clerk";
  // 初始化默认筛选项数值
  let defForm = {
    store_name:'',
    store_id: '',
    type_id: undefined,
    level_id: undefined,
    clerk_name: '',
    clerk_phone: '',
    is_can_verify: 1,
    clerk_password: '123456',
  }
  export default {
    name: 'clerkAdd',
    components: {},
    props: {
      formData: {
        type: Object
      },
      typeList: {
        type: Array
      },
      levelList: {
        type: Array
      },
    },
    setup(props, { emit }) {
      //pass
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 3 },
        wrapperCol: { span: 12 },
        showStore: false,
        dealer_id:'',
        formData:{},
        storeList:[],
        rules: {
          store_name: [
            { required: true, message: '请选择所属门店' }
          ],
          level_id: [
            { required: true, message: '请选择员工级别' }
          ],
          type_id: [
            { required: true, message: '请选择员工类型' }
          ],
          clerk_name: [
            { required: true, message: '请输入员工名称' }
          ],
          clerk_phone: [
            { required: true, message: '请输入员工手机号' }
          ],
          clerk_password: [
            { required: true, message: '请输入密码' }
          ],
        }
      });
      const ruleForm = ref()
      const _lodash = inject("_lodash");
      const getMore = async() =>{
        let res = await getStoreClerkMore(props.formData.id).then(res => res.data);
        if (iscode(res)) {
          form.value = res.data;
        } else {
          message.error(res.msg);
        }
      }
      //选择类型
      const handleChange = (e) =>{
        emit('typechange', e)
        form.value.level_id=''
      }
      const onSubmit = () => {
        ruleForm.value.validate().then(() => {
          emit('onsubmit', form.value)
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      //选择门店
      const select = (e) => {
        if (e == 0) {
          form.value.store_id = e
          form.value.store_name = '总部'
        }else{
          form.value.store_id = e.id
          form.value.store_name = e.store_name
        }
        state.showStore = false
        state.storeList = [e]
      }
      onMounted(() => {
        state.formData = props.formData
        if(props.formData.id){
          getMore();
        }
      });
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
        select,
        handleChange
      }
    }
  }
</script>
